export default {
      id: "i-advantage3-usage",
      viewBox: "0 0 55 55",
      url: __webpack_public_path__ + "img/sprite.svg#i-advantage3",
      toString: function () {
        return this.url;
      }
    }